import React, { useState } from "react";
import { Table, Divider } from "antd";
import { useHistory } from "react-router-dom";

const Content = (props) => {
  const {
    dataSource,
    page,
    onTableChange = () => {},
    onShowSizeChange = () => {},
    onEdit = () => {},
  } = props;

  const history = useHistory();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const handleRedirect = (current, type) => {
    if (type === "position") {
      history.push(`/page/brand/position/${current.companyId}`);
    } else if (type === "topup") {
      history.push(`/page/brand/detail/${current.companyId}`);
    } else {
      history.push(`/page/brand/consumption/${current.companyId}`);
    }
  };

  const columns = [
    {
      title: "品牌商名称",
      dataIndex: "companyName",
      key: "companyName",
    },
    {
      title: "联系人",
      dataIndex: "contacts",
      key: "contacts",
    },
    {
      title: "联系方式",
      dataIndex: "telephone",
      key: "telephone",
    },
    {
      title: "登录账号",
      dataIndex: "mobilePhone",
      key: "mobilePhone",
    },
    {
      title: "账户余额/元",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "投放点位",
      dataIndex: "pointNum",
      key: "pointNum",
      render: (text, record) => {
        return (
          <a href="#" onClick={() => handleRedirect(record, "position")}>
            {text}
          </a>
        );
      },
    },
    {
      title: "渠道商",
      dataIndex: "channelCompanyName",
      key: "channelCompanyName",
    },
    {
      title: "操作",
      dataIndex: "name",
      key: "name",
      render: (_, record) => {
        return (
          <div>
            <a onClick={() => onEdit(record)}>编辑</a>
            <Divider type="vertical" />
            <a onClick={() => handleRedirect(record, "topup")}>充值明细</a>
            <Divider type="vertical" />
            <a onClick={() => handleRedirect(record, "record")}>消费明细</a>
          </div>
        );
      },
    },
  ];

  return (
    <div className="content">
      <Table
        rowSelection={false}
        dataSource={dataSource}
        rowKey="companyId"
        columns={columns}
        pagination={{
          showTotal: () => `共${page.total}条`,
          total: page.total,
          current: page.pageNum,
          pageSize: page.pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ["10", "20", "30", "40"],
          onChange: onTableChange,
          onShowSizeChange: onShowSizeChange,
        }}
      />
    </div>
  );
};

export default Content;
